<div class="signin-main-container">
    <div class="logo-container">
        <img src="../../../assets/images/CBoT Logo.png" alt="Apptium Logo" class="logo">
    </div>
    <form [formGroup]="signinForm" (ngSubmit)="onSignin()">
        <div class="signin-body">
            <h2 class="signin-sub-title">{{sharedDataContent && sharedDataContent.sign_in.signin_title}}</h2>
            <mat-form-field hideRequiredMarker>
                <mat-label>{{sharedDataContent && sharedDataContent.sign_in.user_name}}</mat-label>
                <input matInput formControlName="username">
            </mat-form-field>
             <mat-form-field hideRequiredMarker>
                <mat-label>{{sharedDataContent && sharedDataContent.sign_in.password}}</mat-label>
                <input matInput type="password" formControlName="password">
            </mat-form-field>
            <div class="signin-footer">
                <button mat-flat-button color="primary" class="login-btn">{{sharedDataContent && sharedDataContent.buttons_list.login}}</button>
            </div>
        </div>
    </form>
</div>
